import type { Registry as Services } from '@ember/service';
import type UsageAnalyticsService from 'lumen/services/usage-analytics';
import { differenceInDays } from 'lumen/utils/dates/native-js-date-utils';

interface TrackAutopilotDayToggleOptions {
  date: Date | string;
  enabled: boolean;
  eventTrigger:
    | 'autopilot-settings'
    | 'calendar-tile'
    | 'day-detail-modal'
    | 'pms-table';
  product: 'pricing-manager' | 'smart-distribution';
  type?: 'pricing';
}

export function trackAutopilotDayToggle(
  usageAnalytics: UsageAnalyticsService,
  hotelAndMarket: Services['hotel-and-market'],
  options: TrackAutopilotDayToggleOptions,
): void {
  const { enabled, eventTrigger, product, date, type } = options;

  // An empty/invalid date (e.g. no matching exception day) must report a null
  // offset rather than NaN, matching the pre-refactor behaviour.
  const parsedDate = new Date(date);
  const daysOffsetFromToday = Number.isNaN(parsedDate.getTime())
    ? null
    : differenceInDays(parsedDate, hotelAndMarket.getLocalTime().toDate());

  usageAnalytics.track(
    enabled ? 'Autopilot Day Enabled' : 'Autopilot Day Disabled',
    {
      eventTrigger,
      product,
      daysOffsetFromToday,
      // Autopilot can only be toggled on a PMS-connected hotel
      // (`pricing_assistant.pms.push_integrated`); every caller reaching this
      // point is PMS-integrated by definition, so this value is hardcoded.
      isPmsConnected: true,
      type,
    },
  );
}
